import gql from 'graphql-tag';

export const AcceptTravelerStayInvite = gql`
    mutation acceptTravelerStayInvite($request: AcceptGuestRequest!) {
        acceptTravelerStayInvite(request: $request) {
            result
        }
    }
`;
